import React, { Component } from 'react'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import PricingPageUI from './PricingPageUI.js'

class PrivacyPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      pricingList: null,
      messageList: null,
      countryCode: this.props.context.session.countryCode,
      countryList: null
    }
  }

  render() {
    return (
      <PricingPageUI
        context={this.props.context}
        messageList={this.state.messageList}
        pricingList={this.state.pricingList}
        countryCode={this.state.countryCode}
        countryList={this.state.countryList}
        onCountryCodeChange={this.onCountryCodeChange}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getCountries(context)
    this.getPricing(context, this.state.countryCode)
    this.getMessages(context)
    document.body.classList.add('sdp')
  }

  getPricing(context, countryCode) {
    let cacheManager = new CacheManager({
      resource: `/api/pub/pricing/countryCodes/${countryCode}`,
      cacheKey: CacheKeys.Pricing(countryCode, context.locale),
      callback: this.getPricingCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getPricingCallback = (response) => {
    this.setState({
      pricingList: response.pricingList,
    })
  }

  onCountryCodeChange = (event) => {
    this.setState({countryCode: event.target.value})
    this.getPricing(this.props.context, event.target.value)
  }

  getCountries(context) {
    let cacheManager = new CacheManager({
      resource: `/api/pub/countries`,
      cacheKey: CacheKeys.Countries(),
      callback: this.getCountriesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(this.props.context)
  }

  getCountriesCallback = (response) => {
    let countryList = response.countryList.map(country => ({key: country.code, value: country.name}))
    this.setState({countryList: countryList})
  }

  getMessages(context) {
    let arr = [
      'c_pricing',
      'c_no_cc_cancel_anytime'
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pg_pricing', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
  }
}

export default PrivacyPageSF
